import axios from "axios";

const getDefaultState = () => {
  return {
    configPcd: null,
    indicacoes: [],
    indicacao: {
      id: 0,
      nome: "",
      cpf: "",
      dtnascimento: "",
      cidade: "",
      endereco: "",
      telefone_pcd: "",
      telefone_colaborador: "",
      tiposistema: "WEB",
    },
  };
};

const indicacaoPcdStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setConfigPcd(state, cfg) {
      state.configPcd = cfg;
    },
    setIndicacoes(state, inds) {
      state.indicacoes = inds;
    },
  },
  actions: {
    async getConfigPcd(context) {
      context.commit("setConfigPcd", null);
      await axios.get("/colaborador/indicacao-pcd/config-pcd").then((res) => {
        if (res.data.success) {
          context.commit("setConfigPcd", res.data.data);
        }
      });
    },
    async getMinhasIndicacoes(context) {
      context.commit("setIndicacoes", []);
      await axios
        .get("/colaborador/indicacao-pcd/minhas-indicacoes")
        .then((res) => {
          if (res.data.success) {
            context.commit("setIndicacoes", res.data.data);
          }
        });
    },
  },
  getters: {},
};

export default indicacaoPcdStore;
